export default __webpack_public_path__ + "c2c3f9fc6cd9193e198f055108f944e8.png";